var exports = {
  "D": "x61f99309--fdc433--messages",
  "p": "x61f99309--fdc433--date",
};

module.exports = exports;
